import { CodeEspece } from './enums/code-espece.enum';
export class Ecoulement {
    static jsonMap = {
        id: { key: 'idRecolte', optional: true },
        idEspece: { key: 'idEspece', optional: true },
        codeEspece: { key: 'codeEspece', optional: true, default: '' },
        idGroupeVarietal: { key: 'idGroupeVarietal', optional: true },
        codeGroupeVarietal: { key: 'codeGroupeVarietal', optional: true, default: '' },
        groupeVarietal: { key: 'groupeVarietal', optional: true, default: '' },
        qteTotaleFrance: { key: 'qteTotaleFrance', optional: true },
        qteBioFrance: { key: 'qteBioFrance', optional: true },
        qteTotaleExport: { key: 'qteTotaleExport', optional: true },
        qteBioExport: { key: 'qteBioExport', optional: true },
        qteTotaleIndustrie: { key: 'qteTotaleIndustrie', optional: true },
        qteBioIndustrie: { key: 'qteBioIndustrie', optional: true },
        qteTotaleFreinte: { key: 'qteTotaleFreinte', optional: true },
        qteBioFreinte: { key: 'qteBioFreinte', optional: true }
    };

    id: number = undefined;
    public idEspece: number = null;
    public codeEspece: string = null;
    idGroupeVarietal: number = null;
    codeGroupeVarietal: string;
    groupeVarietal: string = null;

    qteTotaleFrance: number = null;
    qteBioFrance: number = null;

    qteTotaleExport: number = null;
    qteBioExport: number = null;

    qteTotaleIndustrie: number = null;
    qteBioIndustrie: number = null;

    qteTotaleFreinte: number = null;
    qteBioFreinte: number = null;

    public qteTotale(): number {
        return (
            (this.qteTotaleFrance ? this.qteTotaleFrance : 0) +
            (this.qteTotaleExport ? this.qteTotaleExport : 0) +
            (this.qteTotaleIndustrie ? this.qteTotaleIndustrie : 0) +
            (this.qteTotaleFreinte ? this.qteTotaleFreinte : 0)
        );
    }
    qteBio(): number {
        return this.qteBioFrance + this.qteBioExport + this.qteBioIndustrie + this.qteBioFreinte;
    }

    qteTotaleFrancePC(): number {
        return this.qteTotale() ? this.qteTotaleFrance / this.qteTotale() : undefined;
    }
    qteBioFrancePC(): number {
        return this.qteBio() ? this.qteBioFrance / this.qteBio() : undefined;
    }
    qteTotaleExportPC(): number {
        return this.qteTotale() ? this.qteTotaleExport / this.qteTotale() : undefined;
    }
    qteBioExportPC(): number {
        return this.qteBio() ? this.qteBioExport / this.qteBio() : undefined;
    }
    qteTotaleIndustriePC(): number {
        return this.qteTotale() ? this.qteTotaleIndustrie / this.qteTotale() : undefined;
    }
    qteBioIndustriePC(): number {
        return this.qteBio() ? this.qteBioIndustrie / this.qteBio() : undefined;
    }
    qteTotaleFreintePC(): number {
        return this.qteTotale() ? this.qteTotaleFreinte / this.qteTotale() : undefined;
    }
    qteBioFreintePC(): number {
        return this.qteBio() ? this.qteBioFreinte / this.qteBio() : undefined;
    }

    isTotal = false;
    isAutre(): boolean {
        return ['autVarpomme', 'autVarpoir', 'autVarpoire'].indexOf(this.codeGroupeVarietal) > -1;
    }

    sorting(): string {
        const x = ''.concat(
            this.codeEspece === CodeEspece.POMME ? '0' : this.codeEspece === CodeEspece.POIRE ? '1' : '2',
            this.isTotal ? '1' : '0',
            this.isAutre() ? '1' : '0',
            this.groupeVarietal.toUpperCase()
        );
        return x;
    }
}
